export interface AirconReferenceData {
    id: number;
    registrationNumber: string;
    brand: string;
    modelNumber: string;
    coolingCapacityKw: number | null;
    heatingCapacityKw: number | null;
    acType: string;
    configuration: string;
    availabilityStatus: string;
}

/**
 * Loan product scoping for the QuoteService air-conditioner search. `HESLP` restricts results to the
 * ESC Schedule 2 eligible models (ESC-109); omitting the product returns every model (the ZIPP path).
 */
export type AirconSearchProduct = 'HESLP';
export const HESLP_AIRCON_SEARCH_PRODUCT: AirconSearchProduct = 'HESLP';

export interface AirconSearchResponse {
    results: AirconReferenceData[];
    totalMatches: number;
}
